import AvatarsSlider from "./avatarsSlider"

const sliderAvatars = document.querySelector("#slider_avatar")
if (sliderAvatars) {
    const AvatarsSliderBlock = new AvatarsSlider(sliderAvatars)
    AvatarsSliderBlock.changAvatars()
}
